<div class="input-wrapper d-flex align-items-center gap-2 w-100" [class.text-area-input]="isTextArea()">
    <mat-form-field class="d-flex align-items-center">
        <mat-label>{{fieldName() | translate}}</mat-label>
        @if (!isTextArea())
        {
            <input matInput class="input-content" [type]="this.showPassword() ? 'text' : type()" [formControl]="control()" (focus)="focused.set(true)" (blur)="focused.set(false)">
        }
        @else 
        {
            <textarea matInput [formControl]="control()" (focus)="focused.set(true)" (blur)="focused.set(false)"></textarea>
        }

        @if (suffix() && !!control().value)
        {
            <span matTextSuffix>{{suffix()}}</span>
        }
    </mat-form-field>
    @if (isPassword())
    {
        <button type="button" class="input-toggle-button" (click)="changeInputType($event)">
            <svg-icon [src]="getInputTypeIcon()" class="input-icon d-flex align-items-center"/>
        </button>
    }
    <ng-content />
</div>
@if (showErrors() && !focused() && control().touched) 
{
    @if (control().hasError('invalidZipCode'))
    {
        <mat-error>{{'GENERAL.FIELD_ERRORS.INVALID_ZIPCODE' | translate}}</mat-error>
    }
    @else if (control().hasError('invalidPhone'))
    {
        <mat-error>{{'GENERAL.FIELD_ERRORS.INVALID_PHONE' | translate}}</mat-error>
    }
    @else if (control().hasError('required'))
    {
        <mat-error>{{'GENERAL.FIELD_ERRORS.INPUT_REQUIRED' | translate}}</mat-error>
    }
}
@if (isPassword() && showPasswordErrors())
{
    <app-password-validation-rules [passwordControl]="control()" [focused]="focused()"/>
}
